// custom-actions.service.ts
import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {AuthenticationService} from "@alfresco/adf-core";
import { algAuthorizationHeader } from '../src/lib/alg-auth';

@Injectable({
  providedIn: 'root'
})
export class DeleteSharedLinkService {

  constructor(private http: HttpClient,
              private authService: AuthenticationService) {  }

  deleteSharedLink(node: any) {
    let id;

    if (node.properties['qshare:sharedId']) {
      id = node.properties['qshare:sharedId'];
    } else { id = node.id; }

    const endpointUrl = window.location.origin + `/alfresco/api/-default-/public/alfresco/versions/1/shared-links/${id}`;
    let headers = new HttpHeaders();
    let auth = algAuthorizationHeader(this.authService);
    // @ts-ignore
    headers = headers.append('Authorization', auth);

    return this.http.delete(endpointUrl, {headers: headers});
  }

}
